<template>
  <nuttrema-layout-content-header>
    <instance-details-small-card
       slot="left"
      :details="SysAdminInstanceDetails"
      :image="_get(SysAdminInstanceDetails, 'data.Logo')">
    </instance-details-small-card>

    <nuttrema-group-and-sort
      slot="center"
      class="is-centered">
      <h4 v-if="_has(meta, 'section')" slot="label" class="no-padding is-uppercase is-gray">
        {{ $t(meta.section) }}
      </h4>
      <h4 v-if="_has(meta, 'title')" slot="content" class="content--title">
        {{ $t(meta.title) }}
      </h4>
    </nuttrema-group-and-sort>

    <template slot="right">


      <template v-if="showEdit">
        <slot name="edit">
          <div class="content-header-item">
            <permissions-control-wrapper
               action="label.edit"
              :required-general="$PERMISSIONS_GENERAL.EDIT"
              :permissions="_get(SysAdminInstanceDetails, 'meta.permissions')">
              <el-button
                 slot="allowed"
                 size="mini"
                :disabled="editDisabled"
                :type="options.edit ? 'nuttrema-orange' : ''"
                @click="toggleEdit">
                {{ $t('label.edit') }}
              </el-button>

              <el-button
                slot="not-allowed"
                size="mini"
                type="info"
                class="is-icon-mr-075">
                <i class="far fa-lock-alt"></i>{{ $t('label.edit') }}
              </el-button>
            </permissions-control-wrapper>
          </div>
        </slot>
      </template>

      <div class="content-header-item">
        <el-button
           size="mini"
           type="info"
           class="is-icon-mr-075"
          :plain="true"
          @click="handleShowPage(EVENT.SHOW_PAGE_HELP)">
          <i class="far fa-question"></i>{{ $t('label.help') }}
        </el-button>
       <!--  <el-dropdown class="is-align-right" trigger="click" size="small">
          <el-button size="mini">
            {{ $t('label.options') }} <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <slot name="options"></slot>
            <el-dropdown-item>
              <a @click="handleShowPage(EVENT.SHOW_PAGE_HELP)">
                <i class="far fa-question"></i> {{ $t('label.help') }}
              </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>

    </template>
  </nuttrema-layout-content-header>
</template>

<script>
import Emitter from 'components/mixins/emitter';
import * as EVENT from 'constants/event';

import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';
import InstanceDetailsSmallCard from 'components/ui/card/instance-details-small-card';
import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';

export default {
  name: 'cmpt-team-member-standard-header',
  mixins: [
    Emitter,
  ],
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    editDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    showEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    SysAdminInstanceDetails: {
      type: Object,
      required: true,
      default: null,
    },
    meta: {
      required: false,
    },
  },
  components: {
    NuttremaGroupAndSort,
    InstanceDetailsSmallCard,
    NuttremaLayoutContentHeader,
  },
  data() {
    return {
      EVENT,
      options: {
        edit: false,
      },
    };
  },
  methods: {
    toggleEdit() {
      this.options.edit = !this.options.edit;
      this.$emit('update:edit', this.options.edit);
    },
    handleShowPage(event) {
      this.dispatch('LayoutSetSysAdminInstanceDetails', event);
    },
  },
  created() {
    this.options.edit = this.edit;
  },
  watch: {
    edit(value) {
      this.options.edit = value;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/system-administration/instances/shared/cmpt-sys-admin-instance-standard-header.vue